import { render, staticRenderFns } from "./Drawing.vue?vue&type=template&id=634e348b"
import script from "./Drawing.vue?vue&type=script&lang=js"
export * from "./Drawing.vue?vue&type=script&lang=js"
import style0 from "./Drawing.vue?vue&type=style&index=0&id=634e348b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports